import React from 'react';

export const AttachmentCloseIcon = ({ onClick }: { onClick: () => void }) => (
  <button onClick={onClick} className="absolute top-[-8px] right-[-8px] p-0 border-0 bg-transparent cursor-pointer">
    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" fill="#292929"/>
      <path d="M9.34668 9.34686L14.6529 14.6531" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.6533 9.34686L9.34707 14.6531" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </button>
);
